import CryptoJS from 'crypto-js';
 
export default {
  //随机生成指定数量的16进制key
  generatekey(num) {
    let library = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let key = "";
    for (var i = 0; i < num; i++) {
      let randomPoz = Math.floor(Math.random() * library.length);
      key += library.substring(randomPoz, randomPoz + 1);
    }
    return key;
  },
    
  //加密
  encrypt(word) {
    var key = CryptoJS.enc.Utf8.parse('1RMvrJ38tDag0gxp');
    var iv = CryptoJS.enc.Utf8.parse('O4Sap3Axhn3Y7Byt');
    var encrypted = CryptoJS.AES.encrypt(word, key, {iv:iv, mode:CryptoJS.mode.CBC,
            padding:CryptoJS.pad.Pkcs7 });
    return encrypted.toString();
  },


  //解密
  decrypt(word) {
    var key = CryptoJS.enc.Utf8.parse('1RMvrJ38tDag0gxp');
    var iv = CryptoJS.enc.Utf8.parse('O4Sap3Axhn3Y7Byt');
    var decrypt = CryptoJS.AES.decrypt(word, key, {iv:iv,  mode:CryptoJS.mode.CBC,
      padding:CryptoJS.pad.Pkcs7 });
    return CryptoJS.enc.Utf8.stringify(decrypt).toString();
  }


  
}


// WEBPACK FOOTER //
// ./src/utils/AES.js